<template>
  <transition name="bounce">
    <b-container class="py-5 custom-container container">
      <b-breadcrumb
        :items="items"
        class="pl-0 pt-5 mt-5 bg-transparent"
      ></b-breadcrumb>
      <h2 class="font-weight-bold">
        {{ request ? request.file_request.name : '' }}
      </h2>
      <template v-if="request && request.file_share">
        <b-alert
          show
          v-if="request.file_share.file.status === 'pending approval'"
          variant="warning"
          class="mt-3 border-warning text-center"
        >
          There’s nothing to edit at this moment. Your file is currently pending
          approval. You will find your file under “Files” once it has been
          approved.
        </b-alert>
        <b-alert
          show
          v-if="request.file_share.file.status === 'rejected'"
          variant="danger"
          class="mt-3 border-danger text-center"
        >
          Your file has beed rejected.
          {{ request.file_share.file.file_rejects.reason }}
        </b-alert>
      </template>
      <b-card class="mt-4">
        <div class="mx-auto p-lg-5 w-75">
          <h4 class="my-4 font-weight-bold">
            Request Details
          </h4>
          <b-card-body v-if="request" class="pl-0 align-items-center">
            <b-row class="mb-3">
              <b-col cols="7" sm="7" md="4" lg="4" class="font-weight-bold">
                Requested File
              </b-col>
              <b-col cols="5" sm="5" md="4" lg="4" class="gray--2">
                {{ request.file_request.name }}
              </b-col>
            </b-row>
            <b-row class="mb-3">
              <b-col cols="7" sm="7" md="4" lg="4" class="font-weight-bold">
                Project
              </b-col>
              <b-col cols="5" sm="5" md="4" lg="4" class="gray--2">
                {{ request.file_request.project }}
              </b-col>
            </b-row>
            <b-row class="mb-3">
              <b-col cols="7" sm="7" md="4" lg="4" class="font-weight-bold">
                Due Date
              </b-col>
              <b-col cols="5" sm="5" md="4" lg="4" class="gray--2">
                {{ parseDate(request.file_request.due_date) }}
              </b-col>
            </b-row>
            <b-row class="mb-3">
              <b-col cols="7" sm="7" md="4" lg="4" class="font-weight-bold">
                Requested By
              </b-col>
              <b-col cols="5" sm="5" md="4" lg="4" class="gray--2">
                {{ request.file_request.user.full_name }}
              </b-col>
            </b-row>
            <b-row class="mb-3">
              <b-col cols="7" sm="7" md="4" lg="4" class="font-weight-bold">
                Assigned To
              </b-col>
              <b-col cols="5" sm="5" md="4" lg="4" class="gray--2">
                {{ user ? user.full_name : '' }}
              </b-col>
            </b-row>
            <b-row class="mb-3">
              <b-col cols="7" sm="7" md="4" lg="4" class="font-weight-bold">
                Instructions
              </b-col>
              <b-col cols="5" sm="5" md="4" lg="4" class="gray--2">
                <p>{{ request.file_request.instruction }}</p>
              </b-col>
            </b-row>
          </b-card-body>
        </div>
      </b-card>
      <b-card v-if="request && request.file_share" class="mt-4">
        <div class="mx-auto p-lg-5 w-75">
          <h4 class="font-weight-bold mb-4">
            File Details
          </h4>
          <request-file-form
            :file="request.file_share.file"
            :new="isNewFile"
            v-if="request && request.file_share && request.file_share.file"
          />
        </div>
      </b-card>
    </b-container>
  </transition>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import RequestFileForm from '@/components/forms/RequestFileForm'

export default {
  components: {
    RequestFileForm
  },

  computed: {
    ...mapState({
      request: state => state.requests.request,
      user: state => state.auth.user
    }),

    items() {
      return [
        {
          text: 'File Request',
          to: '/requests'
        },
        { text: this.request ? this.request.file_request.name : '' }
      ]
    },

    isNewFile() {
      return !(
        this.request.file_share &&
        (this.request.file_share.file.status !== 'valid' ||
          this.request.file_share.file.status !== 'rejected' ||
          this.request.file_share.file.status !== 'pending approval')
      )
    }
  },

  methods: {
    ...mapActions({
      getRequestByUser: 'requests/getRequestByUser'
    }),

    async fetchRequest() {
      if (this.loading) return
      this.loading = true

      await this.getRequestByUser(this.$route.params.id).finally(() => {
        this.loading = false
      })
    }
  },

  async mounted() {
    await this.fetchRequest()
  }
}
</script>
